import { cva } from '@/styled-system/css';

export const textButtonIconRecipe = cva({
  base: {},

  variants: {
    tone: {
      'brand': {
        color: { base: 'TextButton.brand.icon.default' },
      },
      'neutral': {
        color: { base: 'TextButton.neutral.icon.default' },
      },
      'neutral-fixed': {
        color: { base: 'TextButton.neutral-fixed.icon.default' },
      },
      'subtle': {
        color: { base: 'TextButton.subtle.icon.default' },
      },
      'critical': {
        color: { base: 'TextButton.critical.icon.default' },
      },
    },
    onImpact: {
      true: {},
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    size: {
      sm: {},
      md: {},
    },
  },

  compoundVariants: [
    {
      tone: 'brand',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.brand.icon.hover',
          _groupActive: 'TextButton.brand.icon.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.neutral.icon.hover',
          _groupActive: 'TextButton.neutral.icon.pressed',
        },
      },
    },
    {
      tone: 'subtle',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.subtle.icon.hover',
          _groupActive: 'TextButton.subtle.icon.pressed',
        },
      },
    },
    {
      tone: 'critical',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.critical.icon.hover',
          _groupActive: 'TextButton.critical.icon.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.neutral-fixed.icon.hover',
          _groupActive: 'TextButton.neutral-fixed.icon.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.neutral.icon.default',
          _groupHover: 'TextButton.onImpact.neutral.icon.hover',
          _groupActive: 'TextButton.onImpact.neutral.icon.pressed',
        },
      },
    },
    {
      tone: 'brand',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.brand.icon.default',
          _groupHover: 'TextButton.onImpact.brand.icon.hover',
          _groupActive: 'TextButton.onImpact.brand.icon.pressed',
        },
      },
    },
    {
      tone: 'critical',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.critical.icon.default',
          _groupHover: 'TextButton.onImpact.critical.icon.hover',
          _groupActive: 'TextButton.onImpact.critical.icon.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.neutral-fixed.icon.default',
          _groupHover: 'TextButton.onImpact.neutral-fixed.icon.hover',
          _groupActive: 'TextButton.onImpact.neutral-fixed.icon.pressed',
        },
      },
    },
  ],
});
